import { Realms } from '../services/authenticationApi';

const GetRealm = (): Realms => {
	const app = import.meta.env.VITE_JOURNEY ?? '';
	switch (true) {
		case app.toLowerCase().includes('acorn'):
			return Realms.ACORN;
		case app.toLowerCase().includes('carrot'):
			return Realms.CARROT;
		case app.toLowerCase().includes('motorcade'):
			return Realms.MOTORCADE;
		case app.toLowerCase().includes('flag'):
			return Realms.FLAG;
		case app.toLowerCase().includes('mypolicy'):
			return Realms.MYPOLICY;
		case app.toLowerCase().includes('streetcover'):
			return Realms.STREET_COVER;
		default:
			return Realms.ACORN;
	}
};

export default GetRealm;
